import { useEffect, useState } from "react";
// import BreadCrumb from "../../components/BreadCrumb";
import { EMPTY_CART_LIST_API, getDataFromApi } from "../../APIs";
import { useNavigate, useParams } from "react-router-dom";
import { EVENTSCATEGORIESBYID, GETVENUESVG, SINGLEEVENT, TICKETSBYEVENTID } from "../../constants";
import HeadingOfEvent from "../../components/HeadingOfEvent";
import EventDetailHeader from "./Components/EventDetailHeader";
import EventTicketDetail from "./Components/EventTicketDetail";

import "./style.css";
import BreadCrumb from "../../components/BreadCrumb";
import { SportTypeToShow } from "../../utils/func";
import { useContext } from "react";
import { filterDataContext } from "../../App";
import NoResultFound from "../../components/NoResultFound";
import MapShow from "../../components/MapShow";
import useWindowDimensions from "../../hooks/useDimensions";
import MapSvg from "./Components/MapSvg";
import CustomModal from "../../components/CustomModal";
import TicketPageLoader from "../../components/Loader/TicketLoader";
import QuantityCheckPopUp from "../../components/QuantityCheck";
import EventErrorPopUp from "./Components/EventErrorPopUp";
import { toast } from "react-toastify";
import ReservationUpdateLoader from "../../components/Loaders/ReservationLoader";


const TicketPage = () => {
  const { width, height } = useWindowDimensions();
  const { whislistItem, setWhishListItem, reserveTicket, fetchCartList, stockAvailabilitydata, setCartData, setReserVationData } = useContext(filterDataContext);
  const [eventData, setEventData] = useState([]);
  const [ticketData, setTicketData] = useState({});
  const [ticketDataWithoutGroup, setTicketDataWithoutGroup] = useState([])
  const [ticketCategories, setTicketCategories] = useState([]);
  const [eventLoader, setEventLoader] = useState(true);
  const [tickerLoader, setTicketLoader] = useState(true);
  const [venueSvg, setVenueSvg] = useState(null)
  const param = useParams();
  const event_id = param.id;
  const navigate = useNavigate();
  const [onHoverCatIdFromEvent, setOnHoverCatIdFromEvent] = useState("")
  const [onHoverCatIDFromSvg, setOnHoverCatIdFromSvg] = useState([])
  const [showMapPopUp, setShowMapPopUp] = useState(false)
  const [svgStatus, setSvgStatus] = useState(false)
  const [showQuantityUpdatePopUp, setShowQuantityUpdatePopUp] = useState(false)
  const [filtereQuantityCheckData, setFilteredQuantityCheckData] = useState([])
  const [showNotifyPopUp, setShowNotifyPopUp] = useState(false)



  useEffect(() => {
    setFilteredQuantityCheckData([])
    if (ticketDataWithoutGroup?.length > 0 && stockAvailabilitydata?.length > 0) {
      function getTicketsWithErrorsAndDetails(ticketsArray1, ticketsArray2) {
        return ticketsArray1.reduce((acc, details) => {
          const errorData = ticketsArray2.find(error => error.ticket_id === details.ticket_id);
          if (errorData) {
            acc.push({ details, error: errorData });
          }
          return acc;
        }, []);
      }
      const filteredData = getTicketsWithErrorsAndDetails(ticketDataWithoutGroup, stockAvailabilitydata);
      if (filteredData?.length > 0) {
        setShowQuantityUpdatePopUp(true)
        setFilteredQuantityCheckData(filteredData)
      } else {
        setShowQuantityUpdatePopUp(false)
        setFilteredQuantityCheckData([])
      }
    }
  }, [ticketDataWithoutGroup, stockAvailabilitydata])


  const getAndSetData = async (url) => {
    let result = await getDataFromApi(url);
    if (result) {
      return result.data.data;
    }
  };

  useEffect(() => {
    if (eventData?.venue_id) {
      fetchMapForEvent(eventData.venue_id)
    }
  }, [eventData])

  const getSingleData = async () => {
    setEventLoader(true);
    setTicketLoader(true);
    setTicketDataWithoutGroup([])
    let event_data = await getAndSetData(SINGLEEVENT + event_id);
    let ticket_data = await getAndSetData(TICKETSBYEVENTID + event_id);
    let ticket_categories = await getAndSetData(
      EVENTSCATEGORIESBYID + event_id
    );
    setTicketCategories(ticket_categories);
    if (ticket_data) {
      setTicketDataWithoutGroup(ticket_data)
      groupedTickets(ticket_data);
    }
    if (event_data) {
      setEventData(event_data);
    }
    setEventLoader(false);
    setTicketLoader(false);
  };
  useEffect(() => {
    getSingleData();
  }, [event_id]);

  const groupedTickets = (data) => {
    let groupedCategories = {};
    data?.forEach((item) => {
      const { category_name } = item;
      if (groupedCategories[category_name]) {
        groupedCategories[category_name].push(item);
      } else {
        groupedCategories[category_name] = [item];
      }
    });
    setTicketData(groupedCategories);
  };


  const handlerSetWhislist = (data, category) => {
    if (category === "event") {
      setWhishListItem([...whislistItem, { event: data }]);
    }
    if (category === "ticket") {
      setWhishListItem([...whislistItem, { event: data }]);
    }
  };

  const handleShowMapPopUp = () => {
    setShowMapPopUp(true)
  }


  const fetchMapForEvent = async (id) => {
    try {
      const response_SVG = await getAndSetData(`${GETVENUESVG}/${id}`)
      if (response_SVG) {
        setVenueSvg({ svg: response_SVG })
        setSvgStatus(true)
      }
      else setSvgStatus(false)
    } catch (error) {
      console.log(error, "VENUES_MAP_API")
    }
  }
  const closePopUp = (func) => {
    func();
  };

  const hanldeClearCart = async () => {
    try {
      const response = await EMPTY_CART_LIST_API()
      if (response && response?.status) {
        fetchCartList()
        setCartData([])
        setReserVationData([])
        toast.success(response?.message)
      } else {
        toast.error(response?.message)
      }
    } catch (error) {
      console.log(error, "clear_cart_list")
    } finally {
      continueBooking()
    }
  }

  const continueBooking = () => {
    setShowNotifyPopUp(false)
  }



  return (
    <div className="Events_booking_page">
      {
        showMapPopUp &&
        <CustomModal closeFunc={closePopUp} closeFuncState={setShowMapPopUp} offOutSideClick disableBackGroundScroll >
          <div id="venue-map" className="venue_popUp" >
            <MapShow venueSvg={venueSvg} categories={ticketCategories} ticketData={ticketDataWithoutGroup} onHoverCatIdFromEvent={onHoverCatIdFromEvent}
              setOnHoverCatIdFromEvent={setOnHoverCatIdFromEvent}
              setOnHoverCatIdFromSvg={setOnHoverCatIdFromSvg}
            />
          </div>
        </CustomModal>
      }

      {
        showQuantityUpdatePopUp &&
        <CustomModal
          closeFunc={closePopUp}
          closeFuncState={setShowQuantityUpdatePopUp}
          children={
            <QuantityCheckPopUp data={filtereQuantityCheckData}
              setState={setShowQuantityUpdatePopUp}
              funcToCall={getSingleData}
              callReserve
            />
          }
        />
      }
      {
        showNotifyPopUp &&
        <CustomModal
          closeFunc={closePopUp}
          closeFuncState={setShowNotifyPopUp}
          offOutSideClick
          children={
            <EventErrorPopUp completePrevious={continueBooking} discard={hanldeClearCart} />
          }
        />
      }
      {
        (tickerLoader || eventLoader) ?
          <TicketPageLoader />
          :
          <>

            <div className="ticket_breadcrumb">
              <BreadCrumb
                eventName={eventData.event_name}
                ticketSport={eventData.sport_type}
              />
            </div>

            {Object.keys(eventData).length > 0 ? (
              <div className="events_container">
                <div className="events_main_section">
                  {/* <ReservationUpdateLoader /> */}
                  <HeadingOfEvent
                    title={SportTypeToShow(eventData.sport_type)}
                    eventLoader={eventLoader}
                  />
                  <EventDetailHeader
                    eventData={eventData}
                    eventLoader={eventLoader}
                    handlerSetWhislist={handlerSetWhislist}
                    checkForWishListStatus={Boolean(
                      whislistItem?.find(item => item.event_id === eventData?.event_id)
                    )}
                  />
                  <div className="event_ticket_container" >
                    <div className="event_ticket_summary">
                      {Object.keys(ticketData).length > 0 ? (
                        <EventTicketDetail
                          tickerLoader={tickerLoader}
                          ticketData={ticketData}
                          ticketCategories={ticketCategories}
                          handlerSetWhislist={handlerSetWhislist}
                          onHoverCatIdFromEvent={onHoverCatIdFromEvent}
                          setOnHoverCatIdFromEvent={setOnHoverCatIdFromEvent}
                          onHoverCatIDFromSvg={onHoverCatIDFromSvg}
                          reserveTicket={reserveTicket}
                          showNotifyPopUp={showNotifyPopUp} setShowNotifyPopUp={setShowNotifyPopUp}
                        />
                      ) : (
                        <NoResultFound
                          heading={
                            "There aren't any tickets available at this moment. Please use the alert bell above to set a reminder if (new) stock comes available."
                          }
                        />
                      )}

                    </div>
                    {
                      svgStatus ?
                        width >= 1025 ?
                          <div id="venue-map">
                            <MapShow venueSvg={venueSvg} categories={ticketCategories} ticketData={ticketDataWithoutGroup} onHoverCatIdFromEvent={onHoverCatIdFromEvent}
                              setOnHoverCatIdFromEvent={setOnHoverCatIdFromEvent}
                              setOnHoverCatIdFromSvg={setOnHoverCatIdFromSvg}
                            />
                          </div> :
                          <MapSvg onClick={handleShowMapPopUp} activeState={showMapPopUp} />
                        :
                        null
                    }
                  </div>
                </div>
              </div>
            ) : (
              !tickerLoader && !eventLoader && <NoResultFound heading={"No Events Detail"} />
            )}

          </>

      }
    </div>
  );
};

export default TicketPage;
